<template>
  <el-drawer v-model="openSupportDrawer" class="help-support-drawer" size="90%" :destroy-on-close="true">
    <div class="airtable-embed-container" v-loading="isLoading" v-if="openType === 'help-support'">
      <iframe
        @load="isLoading = false"
        class="airtable-embed"
        :src="iframeUrl"
        frameborder="0"
        onmousewheel=""
        width="100%"
        height="100%"
        style="background: transparent; border: none"
      ></iframe>
    </div>
    <div class="content-container" v-else>
      <header>
        <h2 v-html="heading"></h2>
      </header>
      <div class="enter" v-html="htmlContainer" id="js-enter"></div>
    </div>
  </el-drawer>
</template>

<script setup>
import { ref, onMounted, watch , getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';
import { ElDrawer } from 'element-plus';

const app = getCurrentInstance();
const eventBus = app.appContext.config.globalProperties.EventBus;
const openType = ref('');
const openSupportDrawer = ref(false);
const iframeUrl = ref('');
const isLoading = ref(false);
const heading = ref('');
const htmlContainer = ref('');

// Creator Portal Sequential ID
const openDrawer = (obj) => {
  

  if (typeof obj === 'object') {
    openType.value = 'custom';
    heading.value = obj.title;
    htmlContainer.value = obj.content;

    openSupportDrawer.value = true;
    handlerEvents();
  } else {
    openType.value = obj;

    switch (obj) {
      case 'privacy-policy':
        // heading.value = 'Privacy Policy';
        // htmlContainer.value = privacyContent;
        window.open('/pages/motom-privacy-policy', '_blank');
        break;

      case 'terms-of-use':
        window.open('/pages/motom-terms-of-use', '_blank');
        // heading.value = 'Terms of Use';
        // htmlContainer.value = termContent;
        break;
    }
  }




};

const handlerEvents = () => {
  setTimeout(() => {
    const enterEl = document.querySelector('#js-enter');
    if (enterEl !== null) {
      const links = enterEl.querySelectorAll('.js-open-popup');
      links.forEach((el) => {
        el.addEventListener('click', () => {
          if (el.innerHTML === 'Privacy Policy') {
            window.open('/pages/motom-privacy-policy', '_blank');
            // heading.value = 'Privacy Policy';
            // htmlContainer.value = privacyContent;
          } else if (el.innerHTML === 'Terms of Use') {
            window.open('/pages/motom-terms-of-use', '_blank');
            // heading.value = 'Terms of Use';
            // htmlContainer.value = termContent;
          }

          handlerEvents();
        });
      });
    }
  }, 100);
};


onMounted(() => {
  eventBus.off('open-global-drawer');
  eventBus.on('open-global-drawer', openDrawer);
});
</script>

<style lang="scss">
.help-support-drawer {
  @media screen and (max-width: $mobile_size) {
    & {
      width: 100% !important;
    }
  }

  .airtable-embed {
    width: 100%;
    height: 100%;
  }

  .el-drawer__header {
    padding: 0;
    margin: 0;
    height: 0px;
  }

  .el-drawer__close-btn {
    position: absolute;
    right: 16px;
    top: 16px;

    .el-icon {
      height: 24px;
      width: 24px;

      svg {
        height: 100%;
        width: 100%;
      }
    }
  }

  .airtable-embed-container {
    height: 100%;
  }

  .content-container {
    padding: 16px 24px 24px;
    background-color: var(--Bg-01);
    min-height: 100%;

    @media screen and (max-width: $mobile_size) {
      & {
        padding: 16px 16px 24px;
      }
    }

    header {
      padding: 0 0 16px;
      margin-bottom: 16px;
      border-bottom: 1px solid var(--Bg-03);

      h2 {
        font: var(--demi-32);

        @media screen and (max-width: $mobile_size) {
          & {
            font: var(--demi-24);
          }
        }
      }
    }

    .enter {
      $margin: 16px;
      color: var(--Text-primary);
      padding-bottom: 16px;
      overflow: hidden;
      
      .open-popup {
        color: var(--Blue-30);
        cursor: pointer;
        text-decoration: underline;
      }

      .section-content > * {
        margin-bottom: $margin;
      }

      .section-content time:first-child {
        display: block;
        margin-bottom: 8px;
      }

      h1 {
        font: var(--medium-26);
        margin: $margin 0;
      }

      h2 {
        font: var(--medium-24);
        margin: $margin 0;
      }

      h3 {
        font: var(--medium-22);
        margin: $margin 0;
      }
      
      h4 {
        font: var(--medium-16);
        margin: $margin 0;
      }

      h5 {
        font: var(--medium-12);
        margin: $margin 0;
      }

      h6 {
        font: var(--medium-10);
        margin: $margin 0;
      }

      ul {
        padding-left: 24px;
        margin-bottom: $margin;

        li {
          margin-bottom: calc($margin / 2);
          list-style: disc;
        }
      }

      ol {
        padding-left: 24px;
        margin-bottom: $margin;

        li {
          margin-bottom: calc($margin / 2);
          list-style: decimal;
        }
      }

      table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: $margin;
        border: 1px solid var(--Border-default);

        th, td {
          border: 1px solid var(--Border-default);
          padding: calc($margin / 2);
        }

        th {
          background-color: var(--Neu-10);
        }
      }

      hr {
        border: none;
        border-top: 1px solid var(--Black-40);
        margin: $margin 0;
      }

      strong {
        font-weight: 700;
      }

      em {
        font-style: italic;
      }

      a {
        color: var(--Blue-30);
        text-decoration: underline;

        &:hover {
          text-decoration: none;
        }
      }

      img {
        max-width: 100%;
        height: auto;
        display: block;
      }
    }

  }
}
</style>
